module.exports = __webpack_public_path__ + "img/10.41a138c4.jpeg";